import FormattedText from './FormattedText';
import { can } from '../../../permissions';
import ResponsiveTable from '../../ReusableComponents/ResponsiveTable';
import ConfirmButton from './ConfirmButton';
import PortalButton from './PortalButton';
import React, { useState } from 'react';
import { MdEdit, MdDelete, MdDownload, MdAdd } from 'react-icons/md';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { usePortalMutation, usePortalDownload, usePortal } from '../hooks';
import { ErrorNotice, Empty } from './Feedback';
import PublicationForm from './PublicationForm';
export default function PublicationManager({ selection }) {
  const { user } = usePortal();
  const allowed = can(user, 'portal_configuracoes', 'edit');
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(null),
    remove = usePortalMutation((d) => `selecoes/${selection.id}/editais/${d.id}`, 'DELETE'),
    download = usePortalDownload();
  return (
    <section className="card module-card module-content">
      <div className="card-body">
        <div className="portal-admin-row">
          <div className="module-content-heading">
            <h2>Editais e comunicados</h2>
            <p>Documentos e comunicados publicados para os candidatos.</p>
          </div>
          <PortalButton
            className="btn btn-success hidethis"
            disabled={!allowed}
            onClick={() => {
              setEditing(null);
              setAdding(true);
            }}
          >
            <MdAdd /> Nova publicação
          </PortalButton>
        </div>
        <p>
          O arquivo original é preservado. Um novo envio com o mesmo título recebe uma nova versão.
        </p>
        <ErrorNotice error={remove.error || download.error} />
        {!selection.publications.length ? (
          <Empty>Nenhuma publicação cadastrada.</Empty>
        ) : (
          <ResponsiveTable className="table table-striped">
            <thead>
              <tr>
                <th>Documento</th>
                <th>Público</th>
                <th>Publicação</th>
                <th className="hidethis">Ações</th>
              </tr>
            </thead>
            <tbody>
              {selection.publications.map((p) => (
                <tr key={p.id}>
                  <td>
                    <FormattedText>{p.title}</FormattedText>
                    <small className="d-block">
                      Versão {p.version} · ordem {p.sort_order}
                    </small>
                    {p.description && (
                      <p className="portal-publication-description" title={p.description.replace(/\*\*/g, '').replace(/^##[ \t]?/gm, '')}>
                        <FormattedText>{p.description}</FormattedText>
                      </p>
                    )}
                  </td>
                  <td>{p.visibility === 'registered' ? 'Inscritos' : 'Público'}</td>
                  <td>
                    {p.published_at
                      ? moment(p.published_at).format('DD/MM/YYYY HH:mm')
                      : 'Rascunho'}
                  </td>
                  <td className="hidethis">
                    <div className="portal-admin-actions actions-group">
                      <PortalButton
                        className="btn btn-sm btn-secondary"
                        title="Baixar documento"
                        disabled={download.isLoading}
                        onClick={() =>
                          download.mutate(
                            {
                              path: `selecoes/${selection.id}/editais/${p.id}/download`,
                            },
                            {
                              onSuccess: (blob) => saveAs(blob, p.file_name),
                            }
                          )
                        }
                        type="button"
                      >
                        <MdDownload />
                      </PortalButton>
                      <PortalButton
                        className="btn btn-sm btn-primary"
                        title="Editar publicação"
                        disabled={!allowed}
                        onClick={() => {
                          setAdding(false);
                          setEditing(p);
                        }}
                        type="button"
                      >
                        <MdEdit />
                      </PortalButton>
                      <ConfirmButton
                        className="btn btn-sm btn-danger"
                        title="Retirar publicação"
                        disabled={!remove.allowed || remove.isLoading}
                        type="button"
                        message={'Retirar esta publicação?'}
                        onConfirm={() =>
                          remove.mutate({
                            id: p.id,
                          })
                        }
                      >
                        <MdDelete />
                      </ConfirmButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </ResponsiveTable>
        )}
        {(adding || editing) && (
          <PublicationForm
            key={editing?.id || 'new'}
            selection={selection}
            item={editing}
            onDone={() => {
              setEditing(null);
              setAdding(false);
            }}
          />
        )}
      </div>
    </section>
  );
}
